  /*============Brand Bar Controller
    ================================*/
  angular
    .module('vppApp')
    .controller('brandBarSecondaryController', brandBarSecondaryController);

  brandBarSecondaryController.$inject = ['$scope', '$state', 'brandBarFactory', '$stateParams', 'vppConfig', 'SetLiveSwapService', 'DealerBrandService'];

  function brandBarSecondaryController($scope, $state, brandBarFactory, $stateParams, vppConfig, SetLiveSwapService, DealerBrandService) {
  };
